import { Tabs } from "antd";
import React from "react";
import DashboardActivities from "../dashboard/DashboardActivities";
import ActivityList from "./ActivityList";
import WelcomeTopbar from "../../components/common/header/WelcomeTopbar";

function Activities() {
  const onChange = (key) => {
    console.log(key);
  };

  const items = [
    {
      key: "All",
      label: "All",
      children: <DashboardActivities />,
    },
    {
      key: "Orders",
      label: "Orders",
      children: <DashboardActivities />,
    },
    {
      key: "Shipments",
      label: "Shipments",
      children: <DashboardActivities />,
    },
    {
      key: "Receiving",
      label: "Receiving",
      children: <DashboardActivities />,
    },
    {
      key: "Bill of Lading",
      label: "Bill of Lading",
      children: <DashboardActivities />,
    },
  ];

  return (
    <div className="flex flex-col">
      <WelcomeTopbar />
      <div className="flex flex-col gap-6 pb-6">
        <div className="flex min-h-14 rounded-t-xl bg-[#D1DFFF] px-6 py-3">
          <div className="flex gap-2 text-lg">
            <div>Activities</div>
          </div>
        </div>
        <div className="flex gap-6 px-6">
          {/* <Tabs
          defaultActiveKey={items?.[0]?.key}
          items={items}
          onChange={onChange}
          className="w-full"
        /> */}
          <ActivityList />
        </div>
      </div>
    </div>
  );
}

export default Activities;
